/* eslint-disable import/prefer-default-export,implicit-arrow-linebreak */
export const getUTCDate = (date = new Date()) =>
  new Date(date.getTime() + date.getTimezoneOffset() * 60 * 1000);

export const getLocalDateFromUTC = (utcDate = new Date()) =>
  new Date(utcDate.getTime() - utcDate.getTimezoneOffset() * 60 * 1000);
